var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading && _vm.loading !== -1 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "topBar stickySearchBox",
          attrs: { "data-search-bar": "" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "responsiveSection__grid gridBox search__grid search__gridSearchBarRow",
            },
            [_c("SearchBar", { key: _vm.searchKey })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { ref: "scrollTrigger" }),
      _vm._v(" "),
      _vm.showSidebar
        ? _c("Sidebar", {
            on: {
              closeSidebar: function ($event) {
                return _vm.updateShowSidebar(false)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      [_c("SearchHeadline")],
      _vm._v(" "),
      _c("section", { staticClass: "responsiveSection" }, [
        _c("div", { staticClass: "responsiveSection__grid gridBox" }, [
          _c(
            "div",
            { staticClass: "search__grid" },
            [
              _vm.hasResults
                ? _c(
                    "div",
                    { staticClass: "resultList search__gridResultList" },
                    [
                      _vm.hasPromoted
                        ? [
                            _vm._l(_vm.promotedArray, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: item.uid,
                                  staticClass:
                                    "resultList__itemWrapper hideOnMobile--block",
                                },
                                [
                                  _c("show-item", {
                                    attrs: {
                                      item: item,
                                      promoted: true,
                                      index: index,
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "hideOnDesktop itemContent__editorialWrapper--mobile",
                                },
                                _vm._l(
                                  _vm.promotedArray,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.uid,
                                        staticClass: "resultList__itemWrapper",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "itemContent__editorial",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.trans("EDITORIAL_PICK")
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("show-item", {
                                          attrs: {
                                            item: item,
                                            promoted: true,
                                            index: index,
                                          },
                                        }),
                                        _vm._v(" "),
                                        index === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "facetedSearch__backgroundWrapper",
                                              },
                                              [_c("FacetedSearchMobile")],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.resultArray, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "resultList__itemWrapper",
                            attrs: {
                              "data-results": "",
                              "data-gtm-contenttype": _vm.entityName(
                                item.identity
                              ),
                            },
                          },
                          [
                            _vm.entityName(item.identity) ===
                              _vm.ent.STATISTIC && !_vm.isMobile
                              ? _c(
                                  "tooltip",
                                  {
                                    attrs: {
                                      settings: { position: "top", width: 600 },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "content",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "aoTable__tooltip",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "aoTable__tooltipImg",
                                                    attrs: {
                                                      src: _vm.getThumbnail(
                                                        item
                                                      ),
                                                      "aria-hidden": "true",
                                                      height: "71",
                                                      width: "100",
                                                      alt: "",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "aoTable__tooltipContent",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "aoTable__tooltipContentTop",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm.getTitle(
                                                                  item
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "aoTable__tooltipContentBottom",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm.getContent(
                                                                  item
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("show-item", {
                                      attrs: {
                                        item: item,
                                        index: index + _vm.promotedArray.length,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("show-item", {
                                  attrs: {
                                    item: item,
                                    index: index + _vm.promotedArray.length,
                                  },
                                }),
                            _vm._v(" "),
                            index === 1 && _vm.promotedArray.length < 2
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "hideOnDesktop--block facetedSearch__backgroundWrapper",
                                  },
                                  [_c("FacetedSearchMobile")],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "row center",
                          attrs: { id: "searchPaginator" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "display-inline-block display-s-block",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pagination paginationRound searchPagination",
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "paginationRound__list" },
                                    [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "pagination__item--back paginationRound__circle--border",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              class: {
                                                paginationRound__circlePrev: true,
                                                "paginationRound__circlePrev--disabled":
                                                  _vm.currentPage === 1,
                                              },
                                              attrs: {
                                                type: "button",
                                                rel: "prev",
                                                "data-gtm": `pagination__previous--${
                                                  _vm.currentPage - 1
                                                }`,
                                                "aria-label":
                                                  _vm.trans("PREVIOUS_PAGE"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setPage(-1)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                    height: "13",
                                                    width: "13",
                                                  },
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      href: "#iconChevronLeftBold",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "text-bold margin-right-10 margin-left-20",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.currentPage) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        { staticClass: "margin-right-10" },
                                        [
                                          _vm._v(
                                            "\n                                        ⁄\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        { staticClass: "margin-right-20" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.totalPages) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "pagination__item--next paginationRound__circle--border",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              class: {
                                                paginationRound__circleNext: true,
                                                "paginationRound__circleNext--disabled":
                                                  _vm.currentPage ===
                                                  _vm.totalPages,
                                              },
                                              attrs: {
                                                type: "button",
                                                rel: "next",
                                                "data-gtm": `pagination__next--${
                                                  _vm.currentPage + 1
                                                }`,
                                                "aria-label":
                                                  _vm.trans("NEXT_PAGE"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setPage(+1)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                    height: "13",
                                                    width: "13",
                                                  },
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      href: "#iconChevronRightBold",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    2
                  )
                : !_vm.loading && _vm.loading !== -1 && !_vm.isArchive
                ? _c("div", { staticClass: "noResultBox" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.archive) +
                        "\n                    "
                    ),
                    _c("div", { staticClass: "newAlert info" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.trans("SEARCH_NO_RESULTS_TITLE"))),
                      ]),
                      _vm._v(" "),
                      Number(_vm.language) !== 0
                        ? _c("div", [
                            _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.trans(
                                      "TEXT_FOR_SEARCH_ONLY_PLATFORM_LANGUAGE"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "noResultBox__link",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.enableAllLanguages()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "LINK_TEST_FOR_ALL_LANGUAGE_SEARCH"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.trans("SEARCH_NO_RESULTS_TEXT_ARCHIVE")
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ])
                        : _c("div", [
                            _c("p", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.trans(
                                      "SEARCH_NO_RESULTS_TEXT_ARCHIVE_WITHOUT_LANGUAGE_FILTER"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]),
                          ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.addArchive },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.trans("SEARCH_ARCHIVE_BUTTON")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : !_vm.loading && _vm.loading !== -1 && _vm.isArchive
                ? _c("div", [
                    _c("div", { staticClass: "newAlert info" }, [
                      _c("b", [
                        _vm._v(_vm._s(_vm.trans("FORM_SEARCH_NO_RESULTS"))),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              [_c("RightColumn", { key: _vm.rerenderTriggerKey })],
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      Number(_vm.idBasic) === 1 && Number(_vm.idStandard) === 0
        ? _c("Banner", { attrs: { corporate: false } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }